export class VatGroupsDto {
  public id?: number;
  public description?: string;
  public code?: number;
}
